import { Avatar, Clickable, Col, GroupAvatar, Icon, NotifBadge, Row, Text } from 'components';
import { isToday } from 'date-fns';
import { normalizeDate, theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ChatItem = ({ item, selected, setSelectedChat, user, navigate }) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  if (!item.lastMessage?.body) {
    if (!item.group && !item.createdBy) {
      return null;
    }

    item.lastMessage = {
      body: t('messages.createdGroup', {
        group: item.users.find((x) => x.user._id === item.createdBy).user.name
      }),
      sender: item.createdBy
    };
  }

  const otherUser = item.users.find((x) => x?.user?._id !== user._id).user,
    showNotif = !!item.users.find((x) => user._id === x.user._id).notifCount,
    //isDeleted = new Date(chatSettings.deletedDate) > new Date(item.updatedAt),
    chatSettings = item.users.find((x) => (x.user?._id || x.user) === user._id);

  if (!otherUser) return null;

  return (
    <Clickable onClick={() => setSelectedChat(item._id)}>
      <Row wid="100%" ht="84px" bg={selected ? theme.GREY_10 : '#fff'}>
        <Col pad={`6px ${isMobile ? 16 : 4}px 6px 16px`}>
          <Row>
            {item.group ? (
              <GroupAvatar chatName={item.name} />
            ) : (
              <Clickable onClick={() => navigate(`/profile/${otherUser.username}`)}>
                <Avatar user={otherUser} showVerified />
              </Clickable>
            )}

            <Col center marg="0 0 0 12px">
              <Row between center>
                <Row center>
                  {chatSettings?.favorite && (
                    <Icon type="starFilled" dimensions={20} col={theme.ORANGE} marg="0 6px 0 0" />
                  )}

                  <Text b1 bold>
                    {otherUser.name}
                  </Text>
                </Row>

                <Text b2 med col={theme.GREY_60}>
                  {normalizeDate(
                    new Date(item.updatedAt),
                    isToday(new Date(item.updatedAt)) ? 'Hour' : 'Days'
                  )}
                </Text>
              </Row>

              <Row between center marg="4px 0 0" wid="100%">
                <Row center>
                  <Text
                    col={showNotif ? '#000' : theme.GREY_60}
                    b1={showNotif}
                    med={showNotif}
                    wid={showNotif ? '244px' : '268px'}
                    textOverflow="ellipsis"
                    overflow="hidden"
                    wordBreak="initial"
                  >
                    {item.lastMessage.body}
                  </Text>
                </Row>

                {showNotif && <NotifBadge />}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Clickable>
  );
};

export default ChatItem;
